module.exports = __webpack_public_path__ + "img/scream.bec7aece.webp";